import React, { Component } from "react";
import { ProgressBar, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { formValueSelector, SubmissionError } from "redux-form";
import WizardFormFirstPage from "./WizardFormFirstPage";
import WizardFormSecondPage from "./WizardFormSecondPage";
import WizardFormThirdPage from "./WizardFormThirdPage";
import WizardFormFourthPage from "./WizardFormFourthPage";
import { lastBlurredField, postBasketData } from "../../../../actions/basket";
import "./styles.css";

type Props = {
  activeKey: string,
  form: string,
  children: number,
  onSelect: Function,
  onSubmit: Function,
  outboundChildren: string,
  inboundChildren: string
};
type State = {
  page: number,
  now: number,
  extra: number
};

class WizardForm extends Component<Props, State> {
  props: Props;
  state: State;

  nextPage: Function;
  previousPage: Function;
  progressIncrease: Function;
  handleSubmit: Function;

  constructor(props: Props) {
    super(props);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.progressIncrease = this.progressIncrease.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.adder = 12.5;
    this.skipPage = 1;

    if (!this.props.isThereAnInboundForm) {
      this.adder = 25;
    }

    this.state = {
      page: 1,
      now: this.adder,
      extra: 0
    };
  }

  nextPage() {
    this.setExtraProgress();
    if (
      this.props.form === "transferDetailsInboundForm" &&
      this.state.page === 2
    ) {
      this.skipPage = 2;
    } else {
      this.skipPage = 1;
    }
    this.setState(
      {
        page: this.state.page + 1 * this.skipPage,
        now: this.state.now + this.adder * this.skipPage
      },
      () => {
        this.setURL();
      }
    );
  }
  setURL() {
    window.history.replaceState(
      null,
      "Airport Transfers to Ski Resorts | Ski-Lifts",
      "/quote/" +
        this.props.qID +
        "/stp2/" +
        this.props.form +
        "/" +
        this.state.page
    );
  }
  goBack() {
    this.setState(
      {
        extra: 0
      },
      this.props.onSubmit()
    );
  }

  thirdPageSubmit = values => {
    let apiResponse = {
      numberOfHoldItems: values["holdLuggage"],
      numberOfBikes: values["bikesSurfboards"],
      numberOfSkis: values["skiSnowboards"]
    };

    return this.props
      .postBasketData(this.props.basketId, this.props.idValue, apiResponse)
      .then(result => {
        if (result.hasFailed) {
          const myArr = result.data.reduce((obj, item) => {
            let name = item.validation_field.substring(11);
            switch (name) {
              case "numberOfSkis":
                name = "skiSnowboards";
                break;
              case "numberOfBikes":
                name = "bikesSurfboards";
                break;
              case "numberOfHoldItems":
                name = "holdLuggage";
                break;
              default:
                break;
            }
            obj[name] = item.message;
            return obj;
          }, {});
          throw new SubmissionError({
            _error:
              myArr["skiSnowboards"] +
              myArr["bikesSurfboards"] +
              myArr["holdLuggage"]
          });
        } else if (!this.props.isThereAnInboundForm) {
          this.nextPage();
        }
      });
  };

  previousPage() {
    this.setExtraProgress();
    this.setState(
      { page: this.state.page - 1, now: this.state.now - this.adder },
      () => {
        this.setURL();
      }
    );
  }

  progressIncrease() {
    this.setState({ now: 100 });
  }
  setExtraProgress(invert = false) {
    if (this.props.form === "transferDetailsInboundForm") {
      this.setState({
        extra: invert ? 0 : 50
      });
    } else {
      this.setState({
        extra: invert ? 50 : 0
      });
    }
  }

  handleSubmit(values) {
    this.setExtraProgress(true);
    if (this.props.isThereAnInboundForm) {
      this.thirdPageSubmit(values);
      this.setState({ now: this.adder * 2, page: 2 }, this.props.onSubmit());
    } else {
      this.setState({ now: this.adder, page: 1 }, this.props.onSubmit());
    }
  }

  handleBlur = name => {
    this.props.lastBlurredField(name);
  };
  render() {
    const inboundTitle = () => (this.state.page === 2 ? "Return Journey" : "");
    const outboundTitle = () =>
      this.state.page === 2 ? "Outbound Journey" : "";
    const { page } = this.state;
    return (
      <div className="wizard-form">
        <h4
          className="text-center"
          style={{ width: "100%", margin: "10px auto", color: "#265886" }}
        >
          Complete your travel details in less than <strong>60 seconds</strong>
        </h4>
        <ProgressBar now={this.state.now + this.state.extra} />
        {this.props.form === "transferDetailsOutboundForm" ? (
          <p>
            <i>
              <strong>{outboundTitle()}</strong>
            </i>
          </p>
        ) : (
          <p>
            <i>
              <strong>{inboundTitle()}</strong>
            </i>
          </p>
        )}
        {page === 1 && (
          <WizardFormFirstPage
            onSubmit={this.nextPage}
            activeKey={this.props.activeKey}
            form={this.props.form}
            handleBlur={this.handleBlur}
            lastBlurred={this.props.lastBlurred}
            postBasketData={this.props.postBasketData}
            basketId={this.props.basketId}
            idValue={this.props.idValue}
            transfers={this.props.transfers}
            initialValues={this.props.initialValues}
          />
        )}
        {page === 2 && (
          <WizardFormSecondPage
            previousPage={this.previousPage}
            onSubmit={this.nextPage}
            children={
              this.props.form === "transferDetailsOutboundForm"
                ? parseInt(this.props.outboundChildren, 10)
                : parseInt(this.props.inboundChildren, 10)
            }
            form={this.props.form}
            transfers={this.props.transfers}
            handleBlur={this.handleBlur}
            lastBlurred={this.props.lastBlurred}
            postBasketData={this.props.postBasketData}
            basketId={this.props.basketId}
            idValue={this.props.idValue}
            help={this.props.help}
            initialValues={this.props.initialValues}
            seatTypes={this.props.seatTypes}
            childAges={this.props.childAges}
          />
        )}
        {page === 3 && (
          <WizardFormThirdPage
            previousPage={this.previousPage}
            onSubmit={this.thirdPageSubmit}
            onSubmitNext={this.handleSubmit}
            form={this.props.form}
            handleBlur={this.handleBlur}
            lastBlurred={this.props.lastBlurred}
            postBasketData={this.props.postBasketData}
            basketId={this.props.basketId}
            idValue={this.props.idValue}
            help={this.props.help}
            transfers={this.props.transfers}
            initialValues={this.props.initialValues}
            isLoading={this.props.isLoading}
            isThereAnInboundForm={this.props.isThereAnInboundForm}
          />
        )}
        {page === 4 && (
          <WizardFormFourthPage
            previousPage={this.previousPage}
            onSubmit={this.handleSubmit}
            form={this.props.form}
            handleBlur={this.handleBlur}
            lastBlurred={this.props.lastBlurred}
            postBasketData={this.props.postBasketData}
            basketId={this.props.basketId}
            idValue={this.props.idValue}
            onSelect={this.props.onSelect}
            isThereAnInboundForm={this.props.isThereAnInboundForm}
            transfers={this.props.transfers}
            initialValues={this.props.initialValues}
          />
        )}
        <div className="text-center" style={{ width: "80%", margin: "auto" }}>
          Your information is secure{" "}
          <a
            href="https://www.ski-lifts.com/privacy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </div>
        {this.props.form === "transferDetailsInboundForm" ? (
          <div className="text-center">
            <Button bsStyle="link" onClick={this.goBack.bind(this)}>
              Return to Outbound Form
            </Button>
          </div>
        ) : null}
      </div>
    );
  }
}

const outboundSelector = formValueSelector("transferDetailsOutboundForm");
const inboundSelector = formValueSelector("transferDetailsInboundForm");

export default connect(
  state => ({
    outboundChildren: outboundSelector(state, "children"),
    inboundChildren: inboundSelector(state, "children"),
    lastBlurred: state.basket.lastBlurredField,
    isLoading: state.errorMessages.isLoading
  }),
  { lastBlurredField, postBasketData }
)(WizardForm);



// WEBPACK FOOTER //
// ./src/containers/QuotePage/TravelDetailsPanel/form/WizardForm.js